import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { forEach } from '@angular/router/src/utils/collection';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-reasignacion-modal',
  templateUrl: './reasignacion-modal.component.html',
  styleUrls: ['./reasignacion-modal.component.css']
})
export class ReasignacionModalComponent implements OnInit {
  private destroy$ = new Subject<void>();
    
  displayedColumns: string[] = ['select', 'nombre', 'correo', 'tipo'];
  dataSource: any = [];
  constructor(
    private dialogRef: MatDialogRef<ReasignacionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private snackbar: MatSnackBar,
    private cdRef: ChangeDetectorRef,
    private spinner: NgxSpinnerService,
    private localSave: LocalSaveService,
    private gateway: GatewayService
  ) {
    // Inicializar formulario con validaciones base
    this.grupoVal = new FormGroup({
      COMENTARIO: new FormControl('', Validators.required),
      reasignacionManual: new FormControl(false),
      tecnicoDestino: new FormControl(''),
      citasSeleccionadas: new FormControl([])
    });

    // Suscripción a cambios del checkbox
    this.grupoVal.get('reasignacionManual').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(value => {
      const comentarioControl = this.grupoVal.get('COMENTARIO');
      const tecnicoControl = this.grupoVal.get('tecnicoDestino');
      const citasControl = this.grupoVal.get('citasSeleccionadas');

      if(value) {
        // Modo manual: todos los campos requeridos
        tecnicoControl.setValidators([Validators.required]);
        citasControl.setValidators([Validators.required]);
      } else {
        // Modo automático: solo comentario requerido
        tecnicoControl.clearValidators();
        citasControl.clearValidators();
      }

      // Actualizar validaciones
      tecnicoControl.updateValueAndValidity();
      citasControl.updateValueAndValidity();
    });

    this.cargarCitas();
    this.cargarTecnicos();
  }
  grupoVal: FormGroup;

  tecnicos: any[] = [];
  
  citas: any[] = [];
  citasReasignar: any[] = [];
  seleccionados: any[] = [];

  mensaje: any = '';
  contratas: any = [];

  async ngOnInit() {
    let datos: any = this.data;

    if (datos.msj) {
      this.mensaje = '¿Seguro que desea ' + datos.msj + '?';
    }
    else if (datos.sms) {
      this.mensaje = '¿Seguro que desea ' + datos.sms + '?';
      if (!datos.addcomment) {
        this.grupoVal = new FormGroup({
        });
      }
    }
    else if (datos.msg) {
      this.mensaje = '¿Seguro que desea ' + datos.msg + '?';
      await this.getContratas();
    }
    else {
      this.mensaje = '¿Seguro que desea borrar?';
    }

    if (this.data.sms && !this.data.addcomment) {
      this.grupoVal = new FormGroup({
        reasignacionManual: new FormControl(false),
        campoAdicional: new FormControl('')
      });
    }
  }

  actualizarSeleccion(event: any): void {
    this.seleccionados = event.source.selectedOptions.selected.map((o: any) => o.value);
  }

  transferirSeleccionados(): void {
    const citasTransferir = this.citas.filter(c => this.seleccionados.includes(c.id));
    this.citasReasignar = [...this.citasReasignar, ...citasTransferir];
    this.citas = this.citas.filter(c => !this.seleccionados.includes(c.id));
    this.actualizarValidaciones();
    this.limpiarSeleccion();
  }

  transferirTodos(): void {
    this.citasReasignar = [...this.citasReasignar, ...this.citas];
    this.citas = [];
    this.actualizarValidaciones();
  }

  transferirSeleccionadosAtras(): void {
    const citasDevolver = this.citasReasignar.filter(c => this.seleccionados.includes(c.id));
    this.citas = [...this.citas, ...citasDevolver];
    this.citasReasignar = this.citasReasignar.filter(c => !this.seleccionados.includes(c.id));
    this.actualizarValidaciones();
    this.limpiarSeleccion();
  }

  transferirTodosAtras(): void {
    this.citas = [...this.citas, ...this.citasReasignar];
    this.citasReasignar = [];
    this.actualizarValidaciones();
  }

  private actualizarValidaciones(): void {
    this.grupoVal.get('citasSeleccionadas').setValue(this.citasReasignar.map(c => c.id));
    this.cdRef.detectChanges();
  }

  private limpiarSeleccion(): void {
    this.seleccionados = [];
  }

  private cargarTecnicos(): void {
    this.gateway.get('gettecnicos',
      {
        idcontrata: this.localSave.get('usuarioPGV').IDU,
        idtecnico: this.data.id.ID,
      })
      .then((result: any) => {
        let aux: any = result;
        this.tecnicos = aux.rows;
      }).catch((e: any) => {
      });
  }

  private cargarCitas(): void {
    this.gateway.get('getcitas',
      {
        idagente: this.data.id.ID,
      })
      .then((result: any) => {
        let aux: any = result;
        this.citas = aux.rows;
      }).catch((e: any) => {
      });
  }

  close() {
    this.dialogRef.close({ resp: false });
  }

  getContratas() {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.gateway.get('getdistribuidor',
        {
          IDPADRE: this.localSave.get('usuarioPGV').IDU,
          IDAREA: this.localSave.get('usuarioPGV').IDAREA,
          NUM_PAGINA: 0,
          FILTRO: null,
          NUM_ELEMENTOS: 1000,
          IDPAIS: 5
        })
        .then((result: any) => {
          let aux: any = result;
          this.contratas = aux.rows;
          this.dataSource = this.contratas;
          this.spinner.hide();
          resolve(true);
        }).catch((e: any) => {
          this.spinner.hide();
          resolve(false);
        });
    });
  }

  select_serv(element: any, event: Event) {
    if (event) {
      alert('hola');
      event.stopPropagation();
    }

    const distribuidor = this.contratas.find(item => item.iddistribuidor === element.iddistribuidor);
    if (distribuidor) {
      distribuidor.check = distribuidor.check == 1 ? 0 : 1;
    }
    this.dataSource = this.contratas;
  }

  evitarCheck(event: MouseEvent) {
    // Evita que el checkbox cambie de estado
    event.preventDefault();
  }

  delete() {
    
    const idRolAdmin = 16;

    const formData = {
      ...this.grupoVal.value,
      idTecnicoActual: this.data.id.ID,
      idcontrata: this.localSave.get('usuarioPGV').IDU,
      iddistribuidor: this.data.id.iddistribuidor,
      esAdmin: Number(this.localSave.get('usuarioPGV').idrol) === idRolAdmin ? true : false,
    };
    
    
    let datos: any = this.data;

    // Primera condición: snackb (ahora incluye la lógica de actualización)
    if (datos.snackb) {

      // Construir payload específico para reasignación

      // Mostrar spinner
      this.spinner.show();

      this.gateway.deleteAgente(this.data.operacion, this.data.id, datos.snackb, this.grupoVal.controls.COMENTARIO.value).then((result) => {
        this.dialogRef.close(true);
      }
      ).catch(function (e) {
      });

      // Llamar al método update del gateway
      this.gateway.update('actualizarcitasporagente', formData)
        .then(result => {
          this.spinner.hide();
          this.snackbar.open('Citas reasignadas exitosamente', 'Cerrar', { duration: 3000 });
          this.dialogRef.close(true);
        })
        .catch(error => {
          this.spinner.hide();
          this.snackbar.open('Error en reasignación: ' + error.message, 'Cerrar', { duration: 5000 });
        });

    } 
    // Otras condiciones se mantienen pero sin lógica de actualización
    else if (datos.sms) {
      this.dialogRef.close({ 
        resp: true, 
        comentario: datos.addcomment ? this.grupoVal.controls.COMENTARIO.value : null 
      });
    }
    else if (datos.msj) {
      this.dialogRef.close({ 
        resp: true, 
        comentario: this.grupoVal.controls.COMENTARIO.value, 
        ...this.data.id, 
        operacion: this.data.operacion 
      });
    }
    else if (datos.msg) {
      this.spinner.show();
      const checkOnes = this.contratas.filter(item => item.check === 1);
      if (checkOnes.length > 0) {
        this.data.id.contratas = checkOnes;
    
        this.gateway.update('actualizarcitasporagente', formData)
          .then(result => {
            this.spinner.hide();
            this.snackbar.open('Citas reasignadas exitosamente', 'Cerrar', { duration: 3000 });
            this.dialogRef.close(true);
          })
          .catch(error => {
            this.spinner.hide();
          });
    
      } else {
        this.spinner.hide();
        this.snackbar.open('Debe seleccionar al menos una contrata', 'Cerrar', { duration: 5000 });
      }
    }
    else {
      this.spinner.show();
      this.gateway.delete(
        this.data.operacion, 
        this.data.id, 
        'Eliminado con éxito'
      ).then((result) => {
        this.dialogRef.close(true);
      }).catch(e => {
      });
    }
    
  }
  

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
